var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMonitoredAccountAmber = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FF4D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53994 7.02591C3.53186 6.92124 3.52532 6.82663 3.52005 6.74351C6.33127 6.01351 7.92643 5.24743 10.2604 3.60565C12.6675 5.18098 14.2547 5.92564 16.9511 6.72114C16.9402 6.801 16.9275 6.89106 16.9128 6.9901C16.8492 7.4182 16.7493 8.01219 16.6043 8.67489C16.3106 10.0171 15.8449 11.5771 15.1585 12.6292C14.4732 13.6797 13.2022 14.7855 12.0602 15.6484C11.4965 16.0744 10.9773 16.4316 10.5992 16.6821C10.4544 16.778 10.3306 16.8582 10.2331 16.9204C10.1248 16.8597 9.98496 16.78 9.82047 16.6834C9.40901 16.4418 8.8454 16.0955 8.23698 15.6771C7.00199 14.8278 5.6504 13.727 4.96545 12.6365C4.3137 11.5988 3.93957 10.05 3.73315 8.70798C3.63143 8.04666 3.57295 7.45352 3.53994 7.02591Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40878 11.5479L7.35892 9.42987L7.26167 9.32939L7.15462 9.41936L5.90349 10.4709L5.77832 10.5761L5.8939 10.6918L9.30607 14.106L9.41559 14.2156L9.52158 14.1026L15.1094 8.14514L15.2182 8.02912L15.096 7.92729L13.8449 6.88476L13.7346 6.79282L13.6379 6.89906L9.40878 11.5479Z",
    fill: "#FF4D00",
    stroke: "white",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMonitoredAccountAmber);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/monitored_account_amber.371de93171e0c866ae8e4159d0e75c83.svg";